var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('iframe',{attrs:{"src":_vm.iframeSource,"frameborder":"0","width":"100%","height":"100%","scrolling":"no"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }